import gql from 'graphql-tag';
import { DEAL_BUILDER_QUOTE_FRAGMENT } from './fragments/dealBuilderQuote.fragment';

export const GET_DEAL_BUILDERS = gql`
  query GetDealBuilders($vendorOpportunityId: ID!) {
    dealBuilder {
      getDealBuilders(vendorOpportunityId: $vendorOpportunityId) {
        success
        error
        entity {
          proposalId
          proposal {
            createdDateTime
            businessName
            firstName
            lastName
            saleType
            amountRequested
            status
            salesPersonName
            vendorOpportunityId
            proposalId
            category
            settings {
              configuration {
                formData
                builder
                pricing
                productsConfig
                commonProductsConfiguration
              }
            }
          }
          proposalContacts {
            proposalContactsId
            proposalId
            ownerPgId
            accountContactId
          }
          proposalEquipments {
            proposalEquipmentsId
            proposalId
            equipmentId
          }
          quote {
            ...DealBuilderQuoteFields
          }
        }
      }
    }
  }
  ${DEAL_BUILDER_QUOTE_FRAGMENT}
`;
